import React, { useState, useEffect, useContext } from "react";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Link } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import Note from "./Note";
import { useClientContext } from "../../../Context/ClientContext";
import ClipLoader from "react-spinners/ClipLoader";
import { useGlobalContext } from "../../../Context/GlobalContext";
import ColorPalette from "../../../Context/ClientContext";
import { RxCross2 } from "react-icons/rx";

const Notes = () => {
  const { notes,createNote ,isOpen,setIsOpen,isLoading , getRandomRotation,setNotes,getNotes} = useClientContext();
 const {baseUrl , openToast} = useGlobalContext();

 const [showColorPallate , setShowColorPallate] = useState(false);
 const [selectedColor, setSelectedColor] = useState("");

 console.log(selectedColor);
 

 
  const { control, register, handleSubmit,  formState: { errors } , reset } = useForm();

  const [isEditMode, setIsEditMode] = useState(false);
  const [currentNote, setCurrentNote] = useState(null); 
  console.log(currentNote);
  // open modal to create note
  const openCreateModal = () => {
    setIsEditMode(false);
    setCurrentNote(null);
    reset({ title: "", description: "" });
    setIsOpen(true); 
    setSelectedColor("");
  };
  
  // open modal to edit note
  const openEditModal = (note) => {
    console.log(note);
    setIsEditMode(true); 
    setCurrentNote(note); 
    reset(note); 
    setSelectedColor(note.color || "");
    setIsOpen(true);

  };
  
  // open modal to close modal
  const closeModal = () => {
    setIsEditMode(false);
    setCurrentNote(null);
    setIsOpen(false);
    setSelectedColor("");
  };

 console.log(showColorPallate);
  

  // Customize toolbar to match the features in the image
  const modules = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
    ],
  };

  const formats = ["bold", "italic", "underline", "list", "bullet"];

 //  function to update the note
 const updateNote = async (id, updatedData) => {
  console.log(id,updatedData);
  try {
    const response = await fetch(`${baseUrl}notes/${id}`, {
      method: "PUT", 
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedData),
    });

    const result = await response.json();
    console.log(result);

    if (response.status === 200) {
     getNotes();
      openToast("Note updated successfully!", "success");
      closeModal(); 
      reset();
    } 
    else {
      openToast(result.message || "Failed to update the note", "error");
    }
  } catch (error) {
    console.log(error);
    openToast("Error while updating the note.", "error");
  }
};
  
  // function to remove tags from string
  const stripTags = (input) => {
    if (!input) return "";
    return input.replace(/<\/?[^>]+(>|$)/g, "");
  };
  

  return (
    <div className="main-notes md:p-[20px] h-full">
      <div className="flex items-center">
        <Link className="text-[#8a25b0]" to="/">
          Home
        </Link>
        <div className="flex items-center gap-[8px] ml-[8px]">
          <KeyboardArrowRightIcon />
          <p>Notes</p>
        </div>
        <div className="flex justify-end w-[100%] mx-[35px] my-[10px]">
          <button
            className="px-4 py-2 bg-[#27004a] text-white rounded-md"
            onClick={openCreateModal}
          >
            +
          </button>

          {isOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className={`bg-white p-6 rounded-lg w-[400px] sm:w-[600px] modal-create-note ${showColorPallate && "create-note"} `}>
                <div className="flex justify-between items-center">
                <h2 className="text-xl font-semibold mb-4">Create Note</h2>
                <div className="-mt-5 text-[20px]" onClick={()=>{closeModal()}}>
                 <RxCross2 />
                 </div>
                 </div>
                <div className="mb-[24px]">
                <form
  onSubmit={handleSubmit((data) => {
    const {id , createdAt , ...updatedData} = data
    const noteData = { ...updatedData, color: selectedColor };
    console.log(noteData);
    if (isEditMode) {
      updateNote(currentNote.id, noteData); // Call update API
    } else {
      console.log(data);
      createNote(noteData); // Call create API
    }
    reset(); 
    closeModal();
  })}
>
<div className="w-[100%] xl:[48%] mb-[10px]">
    <label className="text-[14px]">*Title</label>
    <input
      type="text"
      className="border border-1 rounded-md p-[5px] mt-1 w-[100%] bg-[#fff] focus:outline-none text-[#000] placeholder:font-font-normal text-[14px]"
      {...register("title", { required: "Title is required" })}
    />
    {errors.title && <span className="text-red-500 text-[12px]">{errors.title.message}</span>}
  </div>

  <div className="w-[100%] xl:[48%] mb-[10px] quill-controller">
    <label className="text-[14px]">*Description</label>
    <Controller
      name="description"
      control={control}
      rules={{ required: "Description is required" }}
      render={({ field }) => (
        <ReactQuill
          {...field}
          modules={modules}
          formats={formats}
          placeholder="Write your description here..."
          theme="snow"
          className="rounded-md border-none mt-1 w-[100%] h-[150px]"
        />
      )}
    />
    {errors.description && <span className="text-red-500 text-[12px]">{errors.description.message}</span>}
  </div>


  <div
  onClick={()=>{
    console.log("click it")
    setShowColorPallate(true);
  }}
  className="w-full z-50 text-center p-2 bg-white my-5 shadow-lg rounded-lg text-black border border-[#27004a] cursor-pointer"
>
  Color your note
</div>



  <div className="flex justify-end gap-[6px]">
    {/* <button
      type="button"
      className="px-4 py-2 bg-red-500 text-white rounded-md"
      onClick={closeModal}>
      Close
    </button> */}
    <button type="submit" className="px-4 py-2 bg-[#27004a] text-white rounded-md w-full">
      {isEditMode ? "Update" : "Create"}
    </button>
  </div>
</form>

</div>

 </div>
 
 {showColorPallate && <ColorPalette  selectedColor={selectedColor} setShowColorPallate={setShowColorPallate}
  onColorSelect={setSelectedColor}/>
  }
 
 </div>
 
          )}
          
        </div>
      </div>

      <div className="bg-white p-[26px] ">
  <div className="grid gap-x-8 gap-y-4 xl:grid-cols-3 md:grid-cols-2">
    {notes.length > 0 ? (
      notes?.map((note, index) => (
        <Note
          key={note.id}
          openEditModal = {openEditModal}
          id = {note.id}
          title={note?.title}
          description={stripTags(note?.description)}
          color={note?.color}
          createdAt={note?.created_at}
          style={{ transform: `rotate(${getRandomRotation()}deg)` }}

        />
      ))
    ) : isLoading && notes.length === 0 ? (
      <div className="col-span-full flex justify-center items-center">
        <ClipLoader color="#27004a" size={60} />
      </div>
    ) : (
      <div className="col-span-full text-center py-8 bg-gradient-to-r  rounded-lg   flex flex-col justify-center items-center">
        <h1 className="text-4xl font-bold text-[#27004a] drop-shadow-lg mb-4">
          ✍️ Create Your Notes
        </h1>
        <p className="text-lg text-gray-700 font-medium">
          Efficiently capture and organize your professional ideas in one place.
        </p>
      </div>
    )}
  </div>
</div>
</div>
  )
}

export default Notes;





